import { render } from "./index.vue?vue&type=template&id=41006a4d&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=41006a4d&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41006a4d"]])

export default __exports__